const config = {
    captchaKey: process.env.VUE_APP_CAPTCHA_PUBLIC_KEY,
    supportedLocales: ['fr'],
};

export default config;
